module.exports = __webpack_public_path__ + "static/img/掌上门户_0.1bec5b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/掌上门户_0.jpg
// module id = x5xT
// module chunks = 1